import { z } from 'zod';
/** Longitud de un token aleatorio de 32 bytes en base64url sin relleno. */
const RANDOM_TOKEN = /^[A-Za-z0-9_-]{43}$/;
/**
 * Destino tras iniciar sesión: **ruta relativa** de la propia aplicación (09 §6.1).
 * Rechaza URL absolutas, con esquema (`https:`, `javascript:`), protocolo relativo (`//host`),
 * barras invertidas (`/\host`), caracteres de control y espacios. Máximo 2048 caracteres.
 */
export const ReturnToSchema = z
    .string()
    .max(2048)
    .regex(/^\/(?![/\\])[^\\\s\u0000-\u001f\u007f]*$/);
/**
 * Pantalla pública de la web a la que redirige el callback cuando la cuenta no corresponde a un empleado
 * activo (H-04, plan 11 §6). Solo lleva el código: nunca correo, UPN, Object ID ni el texto de Entra.
 */
export const ACCESS_DENIED_PATH = '/acceso-denegado';
export const AccessDeniedCodeSchema = z.enum(['NO_ACTIVE_EMPLOYEE']);
/** `GET /api/v1/auth/login?returnTo=/ruta`. */
export const LoginQuerySchema = z.strictObject({
    returnTo: ReturnToSchema.optional(),
});
/**
 * `GET /api/v1/auth/callback`: respuesta de Entra ID (response_mode=query). No es estricto a
 * propósito: Entra puede añadir parámetros (p. ej. `session_state`) que se ignoran.
 * `error_description` no se usa ni se registra.
 */
export const CallbackQuerySchema = z.object({
    code: z.string().min(1).max(8192).optional(),
    state: z.string().regex(RANDOM_TOKEN),
    error: z
        .string()
        .regex(/^[a-z_]{1,64}$/)
        .optional(),
});
/** Token CSRF sincronizador (32 bytes aleatorios, base64url). Va en la cabecera `X-CSRF-Token`. */
export const CsrfTokenSchema = z.string().regex(RANDOM_TOKEN);
/** `GET /api/v1/auth/session`: caducidades (UTC) y un token CSRF nuevo (rota en cada llamada). */
export const SessionResponseSchema = z.strictObject({
    idleExpiresAt: z.iso.datetime(),
    absoluteExpiresAt: z.iso.datetime(),
    csrfToken: CsrfTokenSchema,
});
/** `POST /api/v1/admin/employees/{id}/sessions/revoke`: parámetros de ruta. */
export const EmployeeIdParamsSchema = z.strictObject({ id: z.uuid() });
/**
 * Cuerpo de la revocación administrativa: motivo obligatorio (09 §6.1). Se guarda en la auditoría;
 * nunca se registra en los logs (la clave `reason` está en la lista de redacción).
 */
export const RevokeSessionsBodySchema = z.strictObject({
    reason: z.string().trim().min(3).max(500),
});
//# sourceMappingURL=auth.js.map